import { AppNS } from 'app';
import { assetUrl } from 'app/helpers/assetUrl';
import FileTypePdfIcon from 'app/ui/icons/FileTypePdfIcon';
import InspectorsIcon from 'app/ui/icons/InspectorsIcon';
import ProfileIcon from 'app/ui/icons/ProfileIcon';
import SettingsIcon from 'app/ui/icons/SettingsIcon';
import WindowBookmarkIcon from 'app/ui/icons/WindowBookmarkIcon';
import AgencyProfileIcon from 'app/ui_v2/icons/AgencyProfileIcon';
import CertificatesMenuIcon from 'app/ui_v2/icons/CertificatesMenuIcon';
import InspectionsMenuIcon from 'app/ui_v2/icons/InspectionsMenuIcon';
import InspectorIcon from 'app/ui_v2/icons/InspectorIcon';
import MessagingIcon from 'app/ui_v2/icons/MessagingIcon';
import TicketsIcon from 'app/ui_v2/icons/TicketsIcon';

export const getBackofficeNavigation = (): AppNS.NavigationElement[] => [
  {
    id: 'inspections',
    name: 'DOB Inspections',
    url: '/dcra-inspections/inspections/scheduled',
    path: ['/dcra-inspections/inspection/:id', '/dcra-inspections/inspections/:sectionId'],
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'dob-inspectors',
    name: 'DOB Inspectors',
    url: '/backoffice/inspectors',
    path: ['/backoffice/inspectors', '/inspectors/:id', '/inspectors/:id/:sectionId'],
    icon: <InspectorsIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'agencies',
    name: 'TP Agencies',
    url: '/backoffice/agency',
    path: ['/backoffice/agency/:id/:section', '/backoffice/agency'],
    icon: <AgencyProfileIcon />,
    disabled: false,
    show: true,
    settings: false,
  },
  {
    id: 'inspectors',
    name: 'TP Inspectors',
    url: '/backoffice/agency/inspector',
    path: ['/backoffice/agency/inspector', `/backoffice/agency/inspector/:id/:section`],
    icon: <InspectorIcon />,
    disabled: false,
    show: true,
    settings: false,
  },
  {
    id: 'tickets',
    name: 'TP Verification',
    url: '/backoffice/tickets',
    path: ['/backoffice/tickets/:id/:section', '/backoffice/tickets'],
    icon: <TicketsIcon />,
    disabled: false,
    show: true,
    settings: false,
  },
  {
    id: 'messaging',
    name: 'Messaging',
    url: '/backoffice/messaging',
    path: '/backoffice/messaging/inbox',
    icon: <MessagingIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'profile',
    name: 'My Profile',
    url: '/backoffice/account',
    path: '/backoffice/account',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: assetUrl('../../../DOB_Construction_Inspections_User_Guide_for_Admins_and_Inspectors.pdf'),
    path: '/guide',
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
  {
    id: 'settings',
    name: `Settings`,
    url: '/backoffice/settings',
    path: '/backoffice/settings',
    icon: <SettingsIcon />,
    disabled: false,
    show: true,
    isExternal: false,
  },
];

export const getElevatorsBackOfficeNavigation = (): AppNS.NavigationElement[] => [
  {
    id: 'elevatorsProjects',
    name: 'Projects',
    url: '/admin/elevators/projects',
    path: '/elevators/projects',
    icon: <WindowBookmarkIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsInspections',
    name: 'Inspections',
    url: '/admin/elevators/inspections',
    path: '/admin/elevators/inspections',
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsCertificates',
    name: 'Certificates',
    url: '/admin/elevators/certificates',
    path: '/admin/elevators/certificates',
    icon: <CertificatesMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: assetUrl('../../../DOB_Construction_Inspections_User_Guide_for_Admins_and_Inspectors.pdf'),
    path: '/guide',
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
];
